/**
 * @fileoverview Notes and documentation route definitions.
 *
 * Page components are lazy-loaded so heavy dependencies (CodeMirror, Mermaid,
 * markdown rendering) are split into their own chunks and only fetched when the
 * relevant route is visited. Suspense fallback is provided by RootLayout.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { createRoutes } from '../utils/routeHelpers';

const AreaCategoryPage = lazy(() => import('../../features/notes/pages/AreaCategoryPage'));
const AreaPage = lazy(() => import('../../features/notes/pages/AreaPage'));
const AreaSubcategoryPage = lazy(() => import('../../features/notes/pages/AreaSubcategoryPage'));
const DocumentationPage = lazy(() => import('../../features/notes/pages/DocumentationPage'));
const EditNotePage = lazy(() => import('../../features/notes/pages/EditNotePage'));
const NotesDisplayPage = lazy(() => import('../../features/notes/pages/NotesDisplayPage'));
const ResourceCategoryPage = lazy(() => import('../../features/notes/pages/ResourceCategoryPage'));
const ResourcePage = lazy(() => import('../../features/notes/pages/ResourcePage'));
const ResourceSubcategoryPage = lazy(() => import('../../features/notes/pages/ResourceSubcategoryPage'));
const SearchResultsPage = lazy(() => import('@/features/search').then((m) => ({ default: m.SearchResultsPage })));

export const notesRoutes: RouteObject[] = createRoutes([
  { path: 'inbox', Component: NotesDisplayPage },
  { path: 'search', Component: SearchResultsPage },
  { path: 'documentation', Component: DocumentationPage },
  { path: 'documentation/new', Component: EditNotePage },
  { path: 'resources/:resourceId', Component: ResourcePage },
  { path: 'resources/:resourceId/category/:categoryId', Component: ResourceCategoryPage },
  { path: 'resources/:resourceId/category/:categoryId/subcategory/:subcategoryId', Component: ResourceSubcategoryPage },
  { path: 'resources/:resourceId/new', Component: EditNotePage },
  { path: 'areas/:areaId', Component: AreaPage },
  { path: 'areas/:areaId/category/:categoryId', Component: AreaCategoryPage },
  { path: 'areas/:areaId/category/:categoryId/subcategory/:subcategoryId', Component: AreaSubcategoryPage },
  { path: 'areas/:areaId/new', Component: EditNotePage },
  { path: 'notes', Component: NotesDisplayPage },
  { path: 'notes/new', Component: EditNotePage },
  { path: ':id/edit', Component: EditNotePage },
]);
